import { useStore } from "@tanstack/react-form";
import displayFormFieldErrors, { useFieldContext } from "../util";
import Input, { InputProps } from "@gradience/ui/dist/components/input";

export function InputField<TInputProps extends InputProps<any, any>>(
  props: TInputProps
) {
  const field = useFieldContext<TInputProps["value"]>();
  const isSubmitting = useStore(
    field.form.store,
    (state) => state.isSubmitting
  );

  return (
    <Input
      {...props}
      value={field.state.value}
      setValue={(value) => field.handleChange(value)}
      style={{ flex: 1, width: "100%", ...props.style }}
      disabled={isSubmitting}
      errorText={displayFormFieldErrors(field.state)}
      inputProps={{
        autoFocus:
          field.state.meta.errors.length > 0 || props.inputProps?.autoFocus,
        style: {
          width: 0,
          ...props.inputProps?.style,
        },
        ...props.inputProps,
      }}
    />
  );
}
